"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateAst = exports.codeToEvaluatedAst = void 0;
var tslib_1 = require("tslib");
var createEvaluateAst = function (handleExpression, handleNonExpression) {
    return function (ast, api) {
        var e_1, _a;
        var res = [];
        try {
            for (var ast_1 = tslib_1.__values(ast), ast_1_1 = ast_1.next(); !ast_1_1.done; ast_1_1 = ast_1.next()) {
                var node = ast_1_1.value;
                if (api.isExpression(node)) {
                    res.push.apply(res, tslib_1.__spreadArray([], tslib_1.__read(handleExpression(node, api)), false));
                }
                else {
                    res.push(handleNonExpression(node));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ast_1_1 && !ast_1_1.done && (_a = ast_1.return)) _a.call(ast_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return res;
    };
};
var evaluateExpression = function (node, api) { return evaluateAstInner(api.getValue(node), api); };
var evaluateAstInner = function (ast, api) {
    return createEvaluateAst(function (node, api) { return evaluateExpression(node, api); }, function (node) { return node; })(ast, api);
};
var evaluateCodeNode = function (value) { return ({ value: value }); };
var codeToEvaluatedAst = function (ast) {
    return ast.map(function (value) { return evaluateCodeNode(value); });
};
exports.codeToEvaluatedAst = codeToEvaluatedAst;
// TODO: Always have origin to values that don't come from an initial value (that are specified directly)
var evaluateAst = function (ast, api) {
    return createEvaluateAst(function (origin, api) { return evaluateExpression(origin, api).map(function (value) { return ({ value: value, origin: origin }); }); }, evaluateCodeNode)(ast, api);
};
exports.evaluateAst = evaluateAst;
//# sourceMappingURL=shorthands-ast-evaluation.js.map